import { inject } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { DataService, Request } from '../services/data-service';
import { Api } from '../services/api';

@inject(DataService, Api, Router)
export class MachineSettings{
	/** Componetn methods **/
	constructor(ds, api, router){
		this.ds 	= ds;
		this.api	= api;
		this.router = router;
		// Variables
		this.selectedFeature = null;
		this.selected_learning_rate = "1e-2";
		this.selected_threshold		= "1e-6";
		this.selected_algorithm		= "";
		this.features				= [];

		this.selected_window_analysis = "30";
		this.selected_batch_range	= 1;
	}

	activate(params){ this.id = params.id; }

	attached(){
		/*	============================================
		  	1 Get machine from dataservice
			2 Get dataset from machine.dataset(split name)
			3 Setup machine and dataset to DataService
			============================================
		*/

		// Load Init fn
		window.setTimeout( () => { this.init(); }, 300);
		
	}

	init(){
		/*	============================================
		  	1 Get machine from dataservice
			2 If machine existis, procede to get dataset
			  else -> get remote machine and dataset
			3 Setup machine and dataset to DataService
			============================================
		*/

		let machine = this.ds.app_data.machine;

		if(!machine){
			// Get remote machine data
			this.getMachine(this.id).then(response => {
				this.handleMachineResponse(response);
				// Get dataset?
				return this.getDataset(this.machine);
			}).then(res => {
				this.handleDatasetResponse(res);
				// For this template
				this.selected_algorithm = this.machine.algorithm
				// Handle selected default options Timeserie
				//this.setupWindowAnalysis(this.dataset, "30");
			});
			
		}
		else{
			// Load machine
			this.machine = machine;
			this.selected_algorithm = this.machine.algorithm
			// Get remote dataset
			window.setTimeout( () => {
				this.getDataset(machine).then(res => { this.handleDatasetResponse(res); });
			}, 1000);

		}
	}

	/** Time series options **/
	setupWindowAnalysis(dataset, window_percent){
		// let samples = dataset.summary.samples;
		let samples = dataset.summary.samples - parseInt(this.selected_batch_range);
		let percent = parseInt(window_percent) / 100;
		let window_analysis = Math.round(samples * percent);
		//console.log("samples, percent, window => ", samples , percent, window_analysis);
		return window_analysis;
	}

	/** API calls **/
	getMachine(id){
		// Request
		let request 	= new Request("/api/v2/machines/id?", "GET");
		let params  	= new URLSearchParams({ id:id });
		request.url 	= request.url + params;
		// Perform remote call
		return this.api.get(request);
	}

	handleMachineResponse(response){
		let status = response.status;
		if(status === 200){
			let machine  = response.data;
			this.machine = machine
			this.ds.app_data.machine = machine;
			
		};
	}

	updateMachine(machine, fields){
		let request = new Request("/api/v2/machines/", "PUT");
		let body		= { machine: machine, fields:fields };
		request.body	= JSON.stringify(body);
		return this.api.put(request);
	}

	handleUpdateMachineResponse(response){
		//console.log("update response => ", response);
	}

	getDataset(machine){
		let request		= new Request("/api/v2/datasets/id/_id?", "GET")
		let id			= machine.dataset.split("-")[0];
		let params		= new URLSearchParams({_id:id});
		request.url		= request.url + params;
		return this.api.get(request);
	}

	handleDatasetResponse(response){
		let status = response.status;
		if(status === 200){
			let dataset 	= response.data;
			this.dataset 	= dataset;
			this.ds.app_data.dataset = dataset;
		}
	}

	/** Action methods **/
	storeFeatures(y_label){
		// Get list of reatures in reverse order
		let features = this.dataset.summary.labels.slice();
		// Exlude y_yablel
		return features.filter(label => label !== y_label)
	}

	onRangeInput(range){
		// console.log("input range => ", range);
	}

	/** Navigation methods **/
	next(){
		// Debug block
		this.machine.stats.learning_rate 	= parseFloat(this.selected_learning_rate);
		this.machine.stats.learning_limit 	= parseFloat(this.selected_threshold);
		this.machine.y_label				= this.selectedFeature;
		this.machine.features				= this.storeFeatures(this.selectedFeature);
		// Update local machine
		let machine = this.machine;
		let id 		= machine._id;
		let fields 	= {
			"y_label"				: this.selectedFeature,
			"algorithm"				: this.selected_algorithm,
			"features"				: this.machine.features,
			"stats.learning_rate"	: machine.stats.learning_rate,
			"stats.learning_limit"	: machine.stats.learning_limit,
			"stats.window_analysis"	: this.setupWindowAnalysis(this.dataset, this.selected_window_analysis),
			"stats.batch_indexes"	: [
				parseInt(this.selected_batch_range),
				this.dataset.summary.samples]
		}

		// Update machine

		this.updateMachine(machine, fields);
		// Update local machine
		this.ds.app_data.machine = machine;
		// Wait to transition
		window.setTimeout( () => {
			this.router.navigateToRoute("models.confirm", { id:id })
		}, 300);

	}
}
